"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleContainer = exports.AnimatedTada = exports.ButtonContainer = exports.StyledTextInput = exports.StyledToggleButton = exports.TippingButtons = exports.Paragraph = exports.Title = exports.MobileDivider = exports.Container = void 0;
const common_buoy_input_1 = require("@buoyhealth/common.buoy-input");
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const styled_components_1 = __importStar(require("styled-components"));
exports.Container = styled_components_1.default.div `
  background-color: ${({ bgColor, theme }) => bgColor ? bgColor : theme.palette.orange[0]};
  padding: 24px;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: ${({ isCard }) => (!isCard ? "0 24px 24px" : "24px")};
  }

  .MuiCollapse-wrapperInner > div {
    margin-top: 12px;
  }

  .MuiFormHelperText-root {
    ${({ theme }) => theme.typography.variants.primary.small};
    color: ${({ theme }) => theme.palette.status.error};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: ${({ isCard }) => (isCard ? "36px 24px" : "0px 16px")};
    // Break out of parent padding
    left: 50%;
    margin: 0 -50vw;
    max-width: 100vw;
    position: relative;
    right: 50%;
  }
`;
exports.MobileDivider = styled_components_1.default.div `
  height: 8px;
  position: relative;
  background-color: ${({ theme }) => theme.palette.gray[0]};
  border-top: ${({ theme }) => `1px solid ${theme.palette.gray[10]}`};
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.gray[10]}`};

  // Break out of parent padding
  left: 50%;
  margin: 0 -50vw;
  max-width: 100vw;
  position: relative;
  right: 50%;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: none;
  }

  &:after {
    content: "";
    border-bottom: ${({ theme, top }) => top && `5px solid ${theme.palette.primary.main}`};
    left: 0;
    right: 0;
    position: absolute;
    top: 8px;
  }
`;
exports.Title = styled_components_1.default.p `
  ${({ large, theme }) => large
    ? theme.typography.variants.primary.large
    : theme.typography.variants.primary.main};
  margin: ${({ large }) => (large ? "0 0 24px" : "0 0 8px")};
`;
exports.Paragraph = styled_components_1.default.p `
  ${({ isCard, theme }) => isCard
    ? theme.typography.variants.secondary.small
    : theme.typography.variants.primary.main};
  ${({ isCard, theme }) => isCard &&
    (0, styled_components_1.css) `
      font-family: ${theme.typography.FontFamily.Secondary} !important;
    `}
  margin: ${({ isCard }) => (isCard ? "8px 0 0" : "0")};
`;
exports.TippingButtons = styled_components_1.default.div `
  display: flex;
  justify-content: space-around;
  margin-bottom: 16px;
  column-gap: 8px;

  input {
    ${({ theme }) => theme.typography.variants.primary.main};
    background-color: ${({ theme }) => theme.palette.common.white};
    color: ${({ theme }) => theme.palette.primary.main};
    text-align: center;

    &::placeholder {
      ${({ theme }) => theme.typography.variants.primary.main};
      color: ${({ theme }) => theme.palette.primary.main};
      text-align: center;
    }

    &:focus::placeholder {
      visibility: hidden;
    }
  }

  .MuiFormGroup-root,
  button {
    flex-basis: 25%;
  }

  .MuiFormGroup-root {
    min-width: 80px;
  }
`;
exports.StyledToggleButton = (0, styled_components_1.default)(ToggleButton_1.default) `
  ${({ theme }) => theme.typography.variants.primary.main};
  color: ${({ theme }) => theme.palette.primary.main};
  background-color: ${({ theme }) => theme.palette.common.white};
  border: 1px solid ${({ theme }) => theme.palette.primary.main};

  &:hover {
    background-color: ${({ theme }) => theme.palette.blue[0]};
  }

  &.Mui-error {
    border-color: ${({ theme }) => theme.palette.status.error};
  }

  &.Mui-selected {
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.common.white};

    &:hover {
      background-color: ${({ theme }) => theme.palette.primary.dark};
    }
  }
`;
exports.StyledTextInput = (0, styled_components_1.default)(common_buoy_input_1.TextInput) `
  .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.palette.primary.main};
  }

  input {
    border-radius: 4px;
  }

  input:not(:placeholder-shown),
  .Mui-focused input {
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: white;
  }
`;
exports.ButtonContainer = styled_components_1.default.div `
  margin-top: ${({ isDialog }) => (isDialog ? "24px" : "16px")};
  ${({ isDialog }) => isDialog &&
    (0, styled_components_1.css) `
    ${exports.TippingButtons} {
      margin-bottom: 24px;
    } }
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: flex;
    align-items: center;
    flex-direction: ${({ isDialog }) => (isDialog ? "column" : "row")};
    ${exports.TippingButtons} {
      margin-bottom: 0;
    }
    ${({ isDialog }) => !isDialog &&
    (0, styled_components_1.css) `
        > .MuiButtonBase-root {
          width: auto;
          margin-left: 16px;
          padding: 11px 45px;
        }
      `};
    ${({ isDialog }) => isDialog &&
    (0, styled_components_1.css) `
        > .MuiButtonBase-root {
          margin-top: 16px;
        }
      `};
  }
`;
exports.AnimatedTada = styled_components_1.default.div `
  animation-name: wave-animation;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  display: inline-block;

  @keyframes wave-animation {
    0% {
      transform: rotate(0deg);
    }
    10% {
      transform: rotate(14deg);
    }
    20% {
      transform: rotate(-8deg);
    }
    30% {
      transform: rotate(14deg);
    }
    40% {
      transform: rotate(-4deg);
    }
    50% {
      transform: rotate(10deg);
    }
    60% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`;
exports.TitleContainer = styled_components_1.default.div `
  ${({ isDialog }) => isDialog &&
    (0, styled_components_1.css) `
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      > .MuiButtonBase-root {
        padding: 0;
      }
      @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
        padding: 24px 0 0 0;
      }
    `}
`;
//# sourceMappingURL=styles.js.map